import * as yup from "yup";

export interface FullNameSuffixData {
    first?: string;
    middle?: string;
    last?: string;
    suffix?: string;
}

export const FullNameSuffixSchema = yup.object<FullNameSuffixData>().shape({
    first: yup.string().label("First name").max(50),
    middle: yup.string().label("Middle name").max(50),
    last: yup.string().label("Last name").max(50),
    suffix: yup.string().label("Suffix").max(50),
});

export const FullNameSuffixRequiredSchema = yup.object<FullNameSuffixData>().shape({
    first: yup.string().required(),
    middle: yup.string(),
    last: yup.string().required(),
    suffix: yup.string(),
}).concat(FullNameSuffixSchema);



// WEBPACK FOOTER //
// ./src/forms/generic/FullNameSuffix.ts